import { MenuService } from './../../services/menu.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { ClassBaseService } from './../../services/class-base.service';
import { NotificationService } from './../../services/notification.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-parent-child-colleges',
  templateUrl: './parent-child-colleges.component.html',
  styleUrls: ['./parent-child-colleges.component.scss']
})
export class ParentChildCollegesComponent implements OnInit, OnDestroy {
  collegeJsonData = [];
  showCollege = true;
  studentUserId: any;
  selectedCollegeData;
  parentChildData: any;
  totalItems = 0;
  dataLoaded = false;
  currentPage = 1;
  maxSize = 10;
  myCollegeStatusJSON = [];
  housingPlanJSON = [];
  currentPageId;
  isSenior: any;
  subs: Subscription[] = [];

  constructor(
    private notificationService: NotificationService,
    private _classBaseService: ClassBaseService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private commonDataSharedService: CommonDataSharedService,
    private _menuService: MenuService
  ) { }

  ngOnInit() {
    localStorage.removeItem('collegeIdData');
    this.parentChildData = JSON.parse(localStorage.getItem('parentChildLocalData'));
    if (this.parentChildData) {
      this.getMyCollegesData();
      this.getMyCollegeStatusData();
    }
    this.subs.push(
      this.commonDataSharedService.parentHomeData.subscribe((data: any) => {
      this.parentChildData = data;
      this.getMyCollegesData();
      this.getMyCollegeStatusData();
      }),
      this.commonDataSharedService.collegeListPageChange.subscribe((obj: any) => {
        this.currentPage = +obj.pageNumber;
        this.maxSize = +obj.pageSize;
        this.getMyCollegesData();
      })
    );

    this.currentPageId = this._menuService.getCurrentPageId();
  }

  back() {
    this.showCollege = true;
  }

  showCollegeDetailPage(item) {
    this.showCollege = false;
    this.selectedCollegeData = {
      collegeid: item.collegeid,
      studentId: item.studentUserId
    }
  }

  onPageSizeChanged() {
    this.getMyCollegesData();
  }

  setPage(pageNo: number) {
    this.currentPage = pageNo;
  };

  getMyCollegeStatusData() {
    this._classBaseService.getApplicationStatusList()
      .subscribe(
        (dataList: any) => {
          this.myCollegeStatusJSON = dataList;
          this.getHousingPlanData();
        },
        () => {
          this.notificationService.show('info', 'No values data exists for this reference type');
        });
  }

  getHousingPlanData() {
        const getMyCollegeStatusInputJson = {
          classTypeName: 'Student Housing Option'
        };
        this._commonRequestResponseService.postWithHeader('admin/values', getMyCollegeStatusInputJson)
          .subscribe(
            (housingPlanJSON: any) => {
              this.housingPlanJSON = housingPlanJSON.items;
              this.getMyCollegesData();
            },
            () => {
              this.notificationService.show('info', 'No values data exists for this reference type');
            });
  }

  getMyCollegesData() {
    const inputJson = {
      studentUserId: this.parentChildData.studentUserId,
      page: this.currentPage,
      pagesize: this.maxSize
    };
    this._commonRequestResponseService.post('student/mycolleges', inputJson)
      .subscribe(
        (collegeJsonData: any) => {
          this.isSenior = collegeJsonData.classYearDescription;
          this.collegeJsonData = collegeJsonData.items || [];
          this.totalItems = collegeJsonData.totalItems;
        },
        () => {
          this.notificationService.show('error', 'Error while calling service');
        }
      );
  }

  ngOnDestroy() {
    this.subs.forEach((sub: Subscription) => {sub.unsubscribe()});
  }
}
